import { v4 as uuidv4 } from 'uuid';
import { valueToFixedNumber } from "./OcrInvoiceHelpers";
import { LineItemTypeOptions } from '../../ocr/types/OcrTypes';
import { BaseOcrDataPageFunctions } from './BaseOcrDataPageFunctions';
/**
 * Extends the Base OCR functions for only logic the Offline Invoices page uses.
 * Offline invoices are invoices that do not have a notch order associated with them.
 */
export class OfflineOcrDataPageFunctions extends BaseOcrDataPageFunctions {
    /**
     * Get the line item data into a format more suitable for the front end display. Basically contains
     * data about the match status.
     */
    transformLineItemToDisplay(matchRow) {
        var _a;
        const primaryObject = matchRow === null || matchRow === void 0 ? void 0 : matchRow.ocrLineItem;
        const secondaryObject = matchRow === null || matchRow === void 0 ? void 0 : matchRow.orderLineItem;
        return {
            primaryItemData: Object.assign({}, primaryObject),
            secondaryItemData: secondaryObject,
            matchResult: matchRow === null || matchRow === void 0 ? void 0 : matchRow.matchResult,
            isRemoved: (matchRow === null || matchRow === void 0 ? void 0 : matchRow.matchResult) === 'onlyOrder' && parseFloat((_a = primaryObject === null || primaryObject === void 0 ? void 0 : primaryObject.quantity) === null || _a === void 0 ? void 0 : _a.toString()) === 0,
            reactKey: uuidv4(),
            defaultLineItem: Object.assign({}, primaryObject),
            defaultMatchResult: matchRow === null || matchRow === void 0 ? void 0 : matchRow.matchResult,
            type: LineItemTypeOptions.PRODUCT,
        };
    }
    /**
     * Given there results from the match we need to mutate the data into data for user consumption.
     * Basically, different states will result in different data being display. Eg we will always display a notch
     * order name for a line item if we have it as the "primary" value not the OCR data - because we don't want
     * the OCR data to attempt to overwrite the notch catalog names (not that it can)
     *
     * I suspect this will be subject to a lot of change and design iteration especially as the UI changes.
     * @param matchResults - match results for the line items
     */
    parseLineItemMatchResultsForDisplay(matchResults) {
        const ocrLineItems = [];
        for (let i = 0; i < matchResults.length; i++) {
            const newLineItem = this.transformLineItemToDisplay(matchResults[i]);
            if (newLineItem.primaryItemData.removedFromOcrInvoice) {
                newLineItem.isRemoved = true;
            }
            ocrLineItems.push(newLineItem);
        }
        return ocrLineItems;
    }
    /**
     * Takes an orderData object from the InvoiceOcrDataPage load and returns all line items from it.
     */
    getLineItemsFromOrderData(orderData) {
        var _a;
        const lineItems = [];
        if ((_a = orderData === null || orderData === void 0 ? void 0 : orderData.products) === null || _a === void 0 ? void 0 : _a.length) {
            for (let i = 0; i < orderData.products.length; i++) {
                const curProduct = orderData.products[i];
                lineItems.push({
                    name: curProduct.productName || '',
                    sku: curProduct.externalRef || '',
                    unit: curProduct.unitName || '',
                    quantity: curProduct.quantity || 0,
                    unitPrice: ((curProduct.pricePerUnit || curProduct.price) || 0) * (curProduct.salesQuantity || 1),
                    weight: (curProduct.finalSalesQuantity || curProduct.totalQuantity) || 0,
                    originalWeight: (curProduct.finalSalesQuantity || curProduct.totalQuantity) || 0,
                    hasFinalSalesQuantitySet: !!curProduct.finalSalesQuantity,
                    taxCode: curProduct.taxCode || '',
                    taxable: curProduct.taxable || false,
                    total: curProduct.total || 0,
                    key: curProduct.key || '',
                    packageID: curProduct.variantCode || '',
                    tax: { dollarAmount: valueToFixedNumber(curProduct.taxAmount), percent: valueToFixedNumber((curProduct.taxAmount / (curProduct.total - curProduct.taxAmount)) * 100) },
                });
            }
        }
        return lineItems;
    }
}
//# sourceMappingURL=OfflineOcrDataPageFunctions.js.map